import { SimulatorType } from "@/types/api/SimulatorType"

export const SIMULATOR_TYPES = [
  {
    group: "Voice to Voice",
    items: [
      {
        id: SimulatorType.VOICE,
        name: "Inbound Voice",
        description: "Your agent picks up calls from users",
      },
      {
        id: SimulatorType.OUTBOUND_VOICE,
        name: "Outbound Voice",
        description: "Your agent calls users",
      },
      {
        id: SimulatorType.OPENAI_REALTIME,
        name: "OpenAI Realtime",
        description:
          "Test prompts directly against OpenAI's Realtime API - no deployed agent required",
      },
      {
        id: SimulatorType.GEMINI_REALTIME,
        name: "Gemini Live",
        description:
          "Test prompts directly against Google's Gemini Live API - no deployed agent required",
      },
      {
        id: SimulatorType.GROK_REALTIME,
        name: "Grok Realtime",
        description:
          "Test prompts directly against xAI's Grok Voice Agent API - no deployed agent required",
      },
      {
        id: SimulatorType.DEEPGRAM_REALTIME,
        name: "Deepgram Voice Agent",
        description:
          "Test prompts directly against Deepgram's Voice Agent API - no deployed agent required",
      },
      {
        id: SimulatorType.WEBSOCKET,
        name: "WebSocket",
        description:
          "Real-time bidirectional communication - suitable for live chat applications",
      },
    ],
  },
  {
    group: "Text to Text",
    items: [
      {
        id: SimulatorType.TEXT,
        name: "Chat",
        description: "HTTP and WebSocket endpoint",
      },
      {
        id: SimulatorType.CHAT_A2A,
        name: "A2A Chat",
        description: "Agent-to-Agent JSON-RPC protocol (e.g. ServiceNow)",
      },
      {
        id: SimulatorType.SMS,
        name: "SMS",
        description: "Text messaging via SMS",
      },
    ],
  },
  {
    group: "Advanced",
    items: [
      {
        id: SimulatorType.LIVEKIT,
        name: "LiveKit",
        description:
          "Advanced real-time audio/video communication platform integration",
      },
      {
        id: SimulatorType.PIPECAT,
        name: "Pipecat Cloud",
        description: "Pipecat Cloud agents",
      },
    ],
  },
  // {
  //   group: "Other",
  //   items: [
  //     {
  //       id: SimulatorType.NOOP,
  //       name: "None",
  //       description:
  //         "No simulation - only run evaluation on the test case inputs.",
  //     },
  //   ],
  // },
] as const
